export class AnnouncementExposures {
    constructor({ bar, popup }) {
        this.bar = bar
        this.popup = popup
        this.popupOpen = false
        this.barShowing = null
        this.settledTrigger = 'sessionStart'
    }

    showBar(announcement, trigger) {
        const settling = announcement ?? null

        // A poll answers with announcement objects of its own, so the bar reports the one it
        // was already showing; beginning again there would record an impression per poll.
        const settled = settling != null && settling.documentId === this.bar.current?.documentId

        this.barShowing = settling

        if (this.popupOpen || settled) {
            return null
        }

        if (settling == null) {
            return this.bar.end()
        }

        return this.bar.begin(settling, trigger ?? this.settledTrigger)
    }

    openPopup(announcement, trigger) {
        this.popupOpen = true
        const ended = this.bar.end()
        this.popup.begin(announcement, trigger)

        return ended
    }

    navigatePopup(announcement, trigger) {
        return this.popup.begin(announcement, trigger)
    }

    imageFailed() {
        this.popup.cancel()
    }

    closePopup() {
        this.popupOpen = false
        this.settledTrigger = 'popupClosed'

        const ended = this.popup.end()

        if (this.barShowing != null) {
            this.bar.begin(this.barShowing, this.settledTrigger)
        }

        return ended
    }

    pause() {
        this.bar.pause()
        this.popup.pause()
    }

    resume() {
        this.bar.resume()
        this.popup.resume()
    }

    refresh() {
        this.bar.refresh()
        this.popup.refresh()
    }
}
